AFRAME.registerComponent('right-panel-data-handler', {
    schema: {
        ticker: { type: 'string', default: '' }
    },

    init: async function () {
        if (__LOG_INFO__) AppLog.info('right-panel-data-handler: Initializing');
        this.apiManager = null;
        this.currentTicker = null;

        try {
            this.apiManager = await RightPanelProxyAPIManager.create();
            if (__LOG_INFO__) AppLog.info('right-panel-data-handler: RightPanelProxyAPIManager initialized successfully');
        } catch (error) {
            if (__LOG_ERROR__) AppLog.error('right-panel-data-handler: Failed to initialize RightPanelProxyAPIManager:', error.message);
            return;
        }

        // This can be triggered from stock-bar.js openStockChart or other stock click handlers
        this.sceneEl = this.el.sceneEl || document.querySelector('a-scene');
        if (this.sceneEl) {
            this.sceneEl.addEventListener('stock-selected', this.onStockSelected.bind(this));
            if (__LOG_INFO__) AppLog.info('right-panel-data-handler: Listening for stock-selected events');
        }

        this.onWatchlistDataLoadedBound = this.onWatchlistDataLoaded.bind(this);
        document.body.addEventListener('watchlist-data-loaded', this.onWatchlistDataLoadedBound);

        if (this.data.ticker) {
            this.updateDataForTicker(this.data.ticker);
        }
    },

    update: async function (oldData) {
        if (!this.apiManager || !this.apiManager.isInitialized) {
            if (__LOG_INFO__) AppLog.info('right-panel-data-handler: API manager not initialized, skipping update');
            return;
        }

        if (oldData.ticker !== this.data.ticker && this.data.ticker) {
            if (__LOG_INFO__) AppLog.info(`right-panel-data-handler: Ticker changed from ${oldData.ticker} to ${this.data.ticker}`);
            await this.updateDataForTicker(this.data.ticker);
        }
    },

    onStockSelected: async function (event) {
        const stock = event.detail;
        if (!stock) {
            if (__LOG_WARN__) AppLog.warn('right-panel-data-handler: stock-selected event has no detail');
            return;
        }

        const ticker = stock.ticker || stock.symbol || stock.tickerSymbol;
        if (!ticker) {
            if (__LOG_WARN__) AppLog.warn('right-panel-data-handler: No ticker found in stock object', stock);
            return;
        }

        if (__LOG_INFO__) AppLog.info(`right-panel-data-handler: Stock selected: ${ticker}`);
        await this.updateDataForTicker(ticker);
    },

    onWatchlistDataLoaded: async function (event) {
        if (document.getElementById('center-chart-overlay') || document.body.dataset.isSearchMode === 'true') {
            if (__LOG_INFO__) AppLog.info('right-panel-data-handler: Ignoring watchlist update because Search Mode is active');
            return;
        }

        if (__LOG_INFO__) AppLog.info('right-panel-data-handler: Watchlist data loaded event received');
        const data = event.detail;
        if (!data || !data.stockInfo) {
            if (__LOG_WARN__) AppLog.warn('right-panel-data-handler: No stockInfo in watchlist event');
            return;
        }

        let firstStock = null;
        if (Array.isArray(data.stockInfo)) {
            if (data.stockInfo.length > 0) {
                firstStock = data.stockInfo[0];
            }
        } else if (typeof data.stockInfo === 'object') {
            const keys = Object.keys(data.stockInfo);
            if (keys.length > 0) {
                firstStock = data.stockInfo[keys[0]];
            }
        }

        if (firstStock) {
            const ticker = firstStock.ticker || firstStock.symbol || firstStock.tickerSymbol || firstStock.T;
            if (ticker) {
                if (__LOG_INFO__) AppLog.info(`right-panel-data-handler: Updating for first stock in watchlist: ${ticker}`);
                await this.updateDataForTicker(ticker);
            } else {
                if (__LOG_WARN__) AppLog.warn('right-panel-data-handler: Could not extract ticker from first stock', firstStock);
            }
        } else {
            if (__LOG_WARN__) AppLog.warn('right-panel-data-handler: Watchlist is empty');
        }
    },

    updateDataForTicker: async function (ticker) {
        if (!ticker) {
            if (__LOG_WARN__) AppLog.warn('right-panel-data-handler: No ticker provided');
            return;
        }

        if (!this.apiManager || !this.apiManager.isInitialized) {
            if (__LOG_ERROR__) AppLog.error('right-panel-data-handler: API manager not initialized');
            return;
        }

        const previousTicker = this.currentTicker;
        this.currentTicker = ticker;

        if (ticker === previousTicker) {
            if (__LOG_INFO__) AppLog.info(`right-panel-data-handler: Refreshing data for ${ticker}`);
        } else {
            if (__LOG_INFO__) AppLog.info(`right-panel-data-handler: Fetching data for ${ticker}...`);
        }

        try {
            const [profileData, performanceData, financialsData] = await Promise.all([
                this.apiManager.fetchCompanyProfile(ticker),
                this.apiManager.fetchStockPerformance(ticker),
                this.apiManager.fetchFinancials(ticker)
            ]);

            if (!profileData) {
                if (__LOG_WARN__) AppLog.warn(`right-panel-data-handler: No profile data returned for ${ticker}`);
            } else {
                if (__LOG_INFO__) AppLog.info(`right-panel-data-handler: Received profile data for ${ticker}:`, profileData);
                this.updateProfileTab(profileData);
            }



            if (!performanceData) {
                if (__LOG_WARN__) AppLog.warn(`right-panel-data-handler: No performance data returned for ${ticker}`);
            } else {
                if (__LOG_INFO__) AppLog.info(`right-panel-data-handler: Received performance data for ${ticker}:`, performanceData);
                this.updatePerformanceTab(performanceData, profileData);
            }

            if (!financialsData) {
                if (__LOG_WARN__) AppLog.warn(`right-panel-data-handler: No financials data returned for ${ticker}`);
            } else {
                if (__LOG_INFO__) AppLog.info(`right-panel-data-handler: Received financials data for ${ticker}:`, financialsData);
                if (__LOG_INFO__) AppLog.info(`📊 Financials data structure for ${ticker}:`, {
                    hasIncome: !!financialsData.income,
                    hasBalance: !!financialsData.balance,
                    hasCashflow: !!financialsData.cashflow,
                    incomeAnnual: financialsData.income?.annual?.length || 0,
                    incomeQuarterly: financialsData.income?.quarterly?.length || 0,
                    balanceAnnual: financialsData.balance?.annual?.length || 0,
                    balanceQuarterly: financialsData.balance?.quarterly?.length || 0,
                    cashflowAnnual: financialsData.cashflow?.annual?.length || 0,
                    cashflowQuarterly: financialsData.cashflow?.quarterly?.length || 0
                });

                if (__LOG_INFO__) AppLog.info(`📊 Full Financials Data for ${ticker}:`, JSON.stringify(financialsData, null, 2));

                if (financialsData.income?.annual?.length > 0) {
                    if (__LOG_INFO__) AppLog.info(`📊 Sample Income Annual Record for ${ticker}:`, financialsData.income.annual[0]);
                }
                if (financialsData.income?.quarterly?.length > 0) {
                    if (__LOG_INFO__) AppLog.info(`📊 Sample Income Quarterly Record for ${ticker}:`, financialsData.income.quarterly[0]);
                }
                if (financialsData.balance?.annual?.length > 0) {
                    if (__LOG_INFO__) AppLog.info(`📊 Sample Balance Annual Record for ${ticker}:`, financialsData.balance.annual[0]);
                }
                if (financialsData.balance?.quarterly?.length > 0) {
                    if (__LOG_INFO__) AppLog.info(`📊 Sample Balance Quarterly Record for ${ticker}:`, financialsData.balance.quarterly[0]);
                }
                if (financialsData.cashflow?.annual?.length > 0) {
                    if (__LOG_INFO__) AppLog.info(`📊 Sample Cashflow Annual Record for ${ticker}:`, financialsData.cashflow.annual[0]);
                }
                if (financialsData.cashflow?.quarterly?.length > 0) {
                    if (__LOG_INFO__) AppLog.info(`📊 Sample Cashflow Quarterly Record for ${ticker}:`, financialsData.cashflow.quarterly[0]);
                }

                this.updateFinancialsTab(financialsData, profileData);
            }

            if (__LOG_INFO__) AppLog.info(`right-panel-data-handler: Successfully updated data for ${ticker}`);
        } catch (error) {
            if (__LOG_ERROR__) AppLog.error(`right-panel-data-handler: Failed to update data for ${ticker}:`, error);
            this.currentTicker = previousTicker;
        }
    },

    updateProfileTab: function (profileData) {
        if (!profileData) {
            if (__LOG_WARN__) AppLog.warn('right-panel-data-handler: No profile data to update');
            return;
        }

        if (__LOG_INFO__) AppLog.info('right-panel-data-handler: Updating profile tab with data:', profileData);
        if (__LOG_INFO__) AppLog.info('right-panel-data-handler: Profile data fields:', {
            companyName: profileData.companyName,
            logo: profileData.logo,
            ticker: profileData.ticker,
            description: profileData.description ? profileData.description.substring(0, 50) + '...' : 'empty',
            address: profileData.address,
            sector: profileData.sector,
            industry: profileData.industry,
            employees: profileData.employees,
            exchange: profileData.exchange,
            type: profileData.type
        });

        const sectorId = this.mapSectorToId(profileData.sector);
        const normalizedSectorName = this.normalizeSectorName(profileData.sector || '');

        const descriptionText = profileData.description || 'empty';

        const updateData = {
            companyName: profileData.companyName || '',
            companyLogo: profileData.logo || '#company-logo-temp',
            ticker: profileData.ticker || this.currentTicker || '',
            description: descriptionText,
            address: profileData.address || '',
            sector: normalizedSectorName || profileData.sector || '',
            industry: profileData.industry || '',
            sectorId: sectorId,
            employees: profileData.employees !== null && profileData.employees !== undefined ? profileData.employees : null,
            employeesNumber: profileData.employees
                ? `Approximately ${this.formatNumber(profileData.employees)}`
                : 'N/A',
            exchange: profileData.exchange || '',
            type: profileData.type || ''
        };

        const scene = document.querySelector('a-scene');
        if (scene) {
            scene.emit('profile-data-updated', updateData);
            if (__LOG_INFO__) AppLog.info(`ks: send data`, updateData);
        }
    },

    updatePerformanceTab: function (performanceData, profileData) {
        if (!performanceData) {
            if (__LOG_WARN__) AppLog.warn('right-panel-data-handler: No performance data to update');
            return;
        }

        const getValue = (val, defaultValue = null) => {
            if (val === 0) {
                return 0;
            }
            if (val === null || val === undefined) {
                return defaultValue;
            }
            return val;
        };

        const getNumericValue = (val) => {
            if (val === 0) {
                return 0;
            }
            if (val === null || val === undefined) {
                return null;
            }
            if (typeof val === 'number' && isNaN(val)) {
                return null;
            }
            return val;
        };

        const getPerformanceValue = (val) => {
            return getNumericValue(val);
        };

        // Map API data to component schema
        // Use null for missing values so component can display N/A
        const updateData = {
            ticker: profileData?.ticker || this.currentTicker || '',
            companyLogo: profileData?.logo || '#company-logo-temp',
            prevClose: getNumericValue(performanceData.prevClose),
            open: getNumericValue(performanceData.open),
            bid: getNumericValue(performanceData.bid),
            ask: getNumericValue(performanceData.ask),
            daysRange: performanceData.daysRange && typeof performanceData.daysRange === 'object'
                ? {
                    low: getNumericValue(performanceData.daysRange.low),
                    high: getNumericValue(performanceData.daysRange.high)
                }
                : { low: null, high: null },
            range52Week: performanceData.range52Week && typeof performanceData.range52Week === 'object'
                ? {
                    low: getNumericValue(performanceData.range52Week.low),
                    high: getNumericValue(performanceData.range52Week.high)
                }
                : { low: null, high: null },
            volume: getNumericValue(performanceData.volume),
            avgVolume: getNumericValue(performanceData.avgVolume),
            marketCap: getNumericValue(performanceData.marketCap),
            sharesOutstanding: getNumericValue(performanceData.sharesOutstanding),
            beta5YMonthly: getNumericValue(performanceData.beta5YMonthly),
            peRatioTTM: getNumericValue(performanceData.peRatioTTM),
            epsTTM_Diluted: getNumericValue(performanceData.epsTTM_Diluted),
            forwardPERatioNTM: getNumericValue(performanceData.forwardPERatioNTM),
            forecastEPSNQTR: getNumericValue(performanceData.forecastEPSNQTR),
            priceToSalesTTM: getNumericValue(performanceData.priceToSalesTTM),
            priceToBookMRQ: getNumericValue(performanceData.priceToBookMRQ),
            priceToFreeCashFlowTTM: getNumericValue(performanceData.priceToFreeCashFlowTTM),
            enterpriseValueToRevenueTTM: getNumericValue(performanceData.enterpriseValueToRevenueTTM),
            enterpriseValueToEBITDA: getNumericValue(performanceData.enterpriseValueToEBITDA),
            earningsDate: performanceData.earningsDate || null,
            forwardDividendAndYield: performanceData.forwardDividendAndYield && typeof performanceData.forwardDividendAndYield === 'object'
                ? {
                    annualDividendPerShare: getNumericValue(performanceData.forwardDividendAndYield.annualDividendPerShare),
                    dividendYield: getNumericValue(performanceData.forwardDividendAndYield.dividendYield)
                }
                : null,
            dividendDate: performanceData.exDividendDate || performanceData.nextEarningsDate || performanceData.recentDividendDate || null,
            shortInterestRatio: getNumericValue(performanceData.shortInterestRatio),
            perfWeek: getPerformanceValue(performanceData.perfWeek),
            perfMonth: getPerformanceValue(performanceData.perfMonth),
            perf6M: getPerformanceValue(performanceData.perf6M),
            perfYTD: getPerformanceValue(performanceData.perfYTD),
            perf1Y: getPerformanceValue(performanceData.perf1Y),
            perf5Y: getPerformanceValue(performanceData.perf5Y)
        };

        const scene = document.querySelector('a-scene');
        if (scene) {
            scene.emit('performance-data-updated', updateData);
            if (__LOG_INFO__) AppLog.info(`performance-data-updated`, updateData);
        }
    },

    updateFinancialsTab: function (financialsData, profileData) {
        if (!financialsData) {
            if (__LOG_WARN__) AppLog.warn('right-panel-data-handler: No financials data to update');
            return;
        }

        if (__LOG_INFO__) AppLog.info('right-panel-data-handler: Updating financials tab with data:', financialsData);

        const updateData = {
            ticker: profileData?.ticker || this.currentTicker || '',
            companyLogo: profileData?.logo || '#company-logo-temp',
            financialsData: financialsData
        };

        if (__LOG_INFO__) AppLog.info('right-panel-data-handler: Financials update data:', {
            ticker: updateData.ticker,
            hasFinancialsData: !!updateData.financialsData,
            hasIncome: !!updateData.financialsData?.income,
            hasBalance: !!updateData.financialsData?.balance,
            hasCashflow: !!updateData.financialsData?.cashflow
        });

        const financialsTabElement = document.querySelector('.financials-tab');
        if (financialsTabElement) {
            if (window.financialsTabData) {
                window.financialsTabData.financialsData = financialsData;
                window.financialsTabData.ticker = updateData.ticker;
            } else {
                window.financialsTabData = {
                    financialsData: financialsData,
                    ticker: updateData.ticker
                };
            }

            const event = new CustomEvent('financials-data-updated', {
                detail: updateData
            });
            document.dispatchEvent(event);
            if (__LOG_INFO__) AppLog.info('right-panel-data-handler: Emitted financials-data-updated event for desktop');
        }

        const financialsTabs = document.querySelectorAll('[financials-tab]');
        if (financialsTabs.length > 0) {
            financialsTabs.forEach((tab, index) => {
                if (__LOG_INFO__) AppLog.info(`right-panel-data-handler: Updating financials-tab component ${index + 1}/${financialsTabs.length}`);
                tab.setAttribute('financials-tab', updateData);

                setTimeout(() => {
                    if (__LOG_INFO__) AppLog.info('right-panel-data-handler: Emitting financials-data-updated event for A-Frame');
                    tab.emit('financials-data-updated', updateData);
                }, 100);
            });
        }

        if (__LOG_INFO__) AppLog.info('right-panel-data-handler: Updated financials-tab', this.currentTicker);
    },

    normalizeSectorName: function (sectorName) {
        if (!sectorName) return '';

        const normalized = sectorName.trim();
        const sectorNormalizationMap = {
            'healthcare': 'Health Care',
            'health care': 'Health Care',
            'basic materials': 'Materials',
            'materials': 'Materials',
            'technology': 'Information Technology',
            'information technology': 'Information Technology',
            'information-technology': 'Information Technology',
            'utilities': 'Utilities',
            'energy': 'Energy',
            'financials': 'Financials',
            'real estate': 'Real Estate',
            'industrials': 'Industrials',
            'communication services': 'Communication Services',
            'consumer staples': 'Consumer Staples',
            'consumer defensive': 'Consumer Staples',
            'consumer discretionary': 'Consumer Discretionary',
            'consumer cyclical': 'Consumer Discretionary'
        };

        const lowerSector = normalized.toLowerCase();
        if (sectorNormalizationMap[lowerSector]) {
            return sectorNormalizationMap[lowerSector];
        }
        if (lowerSector.includes('healthcare') || lowerSector.includes('health care')) {
            return 'Health Care';
        }
        if (lowerSector.includes('basic materials') || (lowerSector.includes('materials') && !lowerSector.includes('information'))) {
            return 'Materials';
        }
        if (lowerSector.includes('technology') || lowerSector.includes('information')) {
            return 'Information Technology';
        }
        if (lowerSector.includes('utilities')) {
            return 'Utilities';
        }
        if (lowerSector.includes('energy')) {
            return 'Energy';
        }
        if (lowerSector.includes('financial')) {
            return 'Financials';
        }
        if (lowerSector.includes('real estate')) {
            return 'Real Estate';
        }
        if (lowerSector.includes('industrial')) {
            return 'Industrials';
        }
        if (lowerSector.includes('communication')) {
            return 'Communication Services';
        }
        if (lowerSector.includes('consumer staples') || lowerSector.includes('consumer defensive')) {
            return 'Consumer Staples';
        }
        if (lowerSector.includes('consumer discretionary') || lowerSector.includes('consumer cyclical') || lowerSector.includes('customer discretionary')) {
            return 'Consumer Discretionary';
        }

        return normalized;
    },

    mapSectorToId: function (sectorName) {
        if (!sectorName) return 1;

        const normalizedName = this.normalizeSectorName(sectorName);

        const sectorMap = {
            'Utilities': 1,
            'Energy': 2,
            'Materials': 3,
            'Financials': 4,
            'Health Care': 5,
            'Real Estate': 6,
            'Information Technology': 7,
            'Industrials': 8,
            'Communication Services': 9,
            'Consumer Staples': 10,
            'Consumer Discretionary': 11
        };

        if (sectorMap[normalizedName]) {
            return sectorMap[normalizedName];
        }
        const lowerSector = normalizedName.toLowerCase();
        for (const [key, value] of Object.entries(sectorMap)) {
            if (key.toLowerCase() === lowerSector) {
                return value;
            }
        }

        return 1;
    },

    formatNumber: function (num) {
        if (num === null || num === undefined) return '0';
        return num.toLocaleString();
    },

    remove: function () {
        if (this.sceneEl) {
            this.sceneEl.removeEventListener('stock-selected', this.onStockSelected.bind(this));
        }
        if (this.onWatchlistDataLoadedBound) {
            document.body.removeEventListener('watchlist-data-loaded', this.onWatchlistDataLoadedBound);
        }
    }
});

